import siddhar from "../Assets/siddhar.jpeg"; // ← uncomment and use your image

const homeStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&family=Cinzel:wght@400;600;700&family=Noto+Serif:ital,wght@0,400;0,600;1,400&display=swap');

  .home-section {
    position: relative;
    background: #FFF8E7;
    overflow: hidden;
    padding: 5rem 2rem 4rem;
  }
  .home-section::before {
    content: '';
    position: absolute; inset: 0;
    background-image:
      radial-gradient(ellipse 60% 40% at 70% 50%, rgba(139,0,0,0.06), transparent),
      url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C9920A' fill-opacity='0.06'%3E%3Cpath d='M30 0L33 27H60L37 43L46 70L30 54L14 70L23 43L0 27H27Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-size: auto, 60px 60px;
    pointer-events: none;
  }
  .home-inner {
    max-width: 1200px; margin: 0 auto;
    display: grid; grid-template-columns: 1fr 1fr;
    gap: 4rem; align-items: center;
    position: relative; z-index: 1;
  }
  .home-label {
    font-family: 'Cinzel', serif;
    font-size: 0.72rem; font-weight: 600;
    letter-spacing: 0.25em; text-transform: uppercase;
    color: #C9920A;
    display: flex; align-items: center; gap: 10px;
    margin-bottom: 1.25rem;
  }
  .home-label::before {
    content: ''; height: 1px; width: 40px;
    background: linear-gradient(90deg, transparent, #C9920A);
  }
  .home-label::after {
    content: ''; height: 1px; width: 40px;
    background: linear-gradient(90deg, #C9920A, transparent);
  }
  .home-title {
    font-family: 'Cinzel Decorative', serif;
    font-size: 2.2rem; font-weight: 700;
    color: #8B0000; line-height: 1.2;
    margin-bottom: 1.5rem;
    text-shadow: 1px 2px 6px rgba(139,0,0,0.15);
  }
  .home-divider {
    display: flex; align-items: center; gap: 1rem;
    margin-bottom: 1.5rem;
  }
  .home-divider span { font-size: 1.4rem; color: #C9920A; }
  .home-divider::before, .home-divider::after {
    content: ''; flex: 1; height: 1px;
    background: linear-gradient(90deg, transparent, #C9920A, transparent);
    max-width: 80px;
  }
  .home-text {
    font-family: 'Noto Serif', serif;
    font-size: 1.05rem; line-height: 1.85;
    color: #3d2010; margin-bottom: 1rem;
  }
  .home-highlights {
    background: linear-gradient(135deg, rgba(139,0,0,0.05), rgba(201,146,10,0.08));
    border: 1px solid rgba(201,146,10,0.25);
    border-left: 3px solid #C9920A;
    border-radius: 0 6px 6px 0;
    padding: 1rem 1.25rem; margin-bottom: 2rem;
    font-family: 'Noto Serif', serif;
    font-size: 0.95rem; color: #5a2a00; font-style: italic;
    line-height: 1.9;
  }
  .home-btn {
    display: inline-flex; align-items: center; gap: 10px;
    font-family: 'Cinzel', serif; font-size: 0.82rem;
    font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase;
    color: #fff;
    background: linear-gradient(135deg, #8B0000, #c0392b);
    padding: 14px 32px; border: none; border-radius: 2px;
    cursor: pointer; box-shadow: 0 4px 20px rgba(139,0,0,0.35);
    transition: all 0.3s; text-decoration: none;
  }
  .home-btn::after { content: '→'; font-size: 1rem; transition: transform 0.3s; }
  .home-btn:hover {
    background: linear-gradient(135deg, #a00000, #e04030);
    box-shadow: 0 6px 28px rgba(139,0,0,0.5);
    transform: translateY(-2px);
  }
  .home-btn:hover::after { transform: translateX(5px); }
  .home-img-wrap {
    position: relative; display: flex;
    justify-content: center; align-items: center;
  }
  .home-img-frame {
    position: relative; width: 100%; max-width: 420px;
  }
  .home-img-frame::before {
    content: ''; position: absolute; inset: -14px;
    border: 2px solid rgba(201,146,10,0.35);
    border-radius: 4px; pointer-events: none; z-index: 2;
  }
  .home-img-frame::after {
    content: ''; position: absolute; inset: -8px;
    border: 1px solid rgba(201,146,10,0.2);
    border-radius: 3px; pointer-events: none; z-index: 2;
  }
  .home-img-frame img {
    width: 100%; border-radius: 4px; display: block;
    box-shadow: 0 20px 60px rgba(0,0,0,0.25);
  }
  .home-img-placeholder {
    width: 100%; aspect-ratio: 3/4; border-radius: 4px;
    background: linear-gradient(160deg, #3d0000 0%, #6b0000 40%, #8B0000 100%);
    display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 1rem;
    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  }
  .deity-icon {
    font-size: 5rem;
    filter: drop-shadow(0 0 20px rgba(240,192,64,0.8));
    animation: floatIcon 4s ease-in-out infinite;
  }
  @keyframes floatIcon {
    0%,100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  .home-img-placeholder p {
    font-family: 'Cinzel', serif; font-size: 0.8rem;
    letter-spacing: 0.15em; color: rgba(240,192,64,0.6);
    text-transform: uppercase;
  }
  .home-badge {
    position: absolute; bottom: -18px; left: -18px;
    background: linear-gradient(135deg, #F0C040, #a07010);
    color: #4A0000;
    font-family: 'Cinzel', serif; font-size: 0.72rem;
    font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    padding: 10px 16px; border-radius: 3px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.3);
    z-index: 5; line-height: 1.5; text-align: center;
  }
  @media (max-width: 768px) {
    .home-inner { grid-template-columns: 1fr; gap: 2.5rem; }
    .home-title { font-size: 1.7rem; }
    .home-img-wrap { order: -1; }
    .home-badge { display: none; }
  }
`;

const Home = () => {
  // To use your real image, replace the placeholder div below with:
  // <img src={siddhar} alt="Sri Ayyalanandha Siddhar" />

  return (
    <>
      <style>{homeStyles}</style>
      <section className="home-section" id="home">
        <div className="home-inner">
          {/* Left Content */}
          <div>
            <p className="home-label">Sacred Spiritual About</p>
            <h1 className="home-title">
              Sri La Sri<br />Ayyalanandha<br />Siddhar
            </h1>
            <div className="home-divider"><span>✦</span></div>
            <p className="home-text">
              Sri La Sri Ayyalanandha Siddhar Jeeva Samadhi Madalayam is a sacred
              spiritual place located in the heart of Vellore. Devotees from across
              the region visit the temple to seek blessings, inner peace, and divine
              guidance.
            </p>
            <div className="home-highlights">
              ✦ Special Poojas every Tuesday · Pournami · Amavasai<br />
              ✦ Auspicious Star Days: Sadhayam &amp; Anusham
            </div>
            <a href="#poojas" className="home-btn">View Pooja Schedule</a>
          </div>

          {/* Right Image */}
          <div className="home-img-wrap">
            <div className="home-img-frame">
              {/* 👇 Replace this placeholder with your actual image: */}
              <img src={siddhar} alt="Sri Ayyalanandha Siddhar" />
              {/* <div className="home-img-placeholder">
                <div className="deity-icon">🕉️</div>
                <p>Your Image Here</p>
              </div> */}
              <div className="home-badge">
                Sri La Sri<br />Ayyalanandha Siddhar
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;